/*
 * @Description: 编辑项目
 * @Date: 2025-03-20 15:47:26
 */
import { route } from './src/router';

const name = 'project-center-edit';
export { name, route };
